import React from 'react';
import PropTypes from 'prop-types';
import Row from 'components/UI/Layout/Row';

function Tab({
    className, children, onChangeTab, activeTab, tabs,
})
{
    return (
        <>
            <Row className={className}>
                {(tabs).map((item, index) => (
                    <div
                        role="button"
                        tabIndex={index}
                        key={item.id}
                        onKeyUp={() =>
                        {
                            onChangeTab(item);
                        }}
                        onClick={() =>
                        {
                            onChangeTab(item);
                        }}
                        className={`${item.id === activeTab ? 'tw-bg-white dark:tw-text-neutral-800 tw-text-ivory' : 'tw-text-gray-500 dark:tw-text-gray-300 dark:tw-bg-neutral-600 tw-bg-gray-300'} tw-whitespace-nowrap tw-flex tw-flex-none last:tw-mr-0 tw-rounded-t tw-text-center tw-cursor-pointer tw-p-5 tw-mr-0.5 tw-min-w-[100px] tw-min-h-[65px]`}
                    >
                        <span
                            type="button"
                            className="tw-font-bold tw-text-base"
                        >
                            {item.title}
                        </span>
                    </div>
                ))}
            </Row>
            <div className="tw-py-4 tw-px-3 tw-bg-white dark:tw-bg-neutral-900 ">
                {children}
            </div>
        </>
    );
}

Tab.propTypes = {
    className: PropTypes.string,
    tabs: PropTypes.array.isRequired,
    children: PropTypes.node.isRequired,
    onChangeTab: PropTypes.func.isRequired,
    activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Tab.defaultProps = {
    activeTab: '',
    className: '',
};

export default Tab;
